module.exports = __webpack_public_path__ + "static/media/6.8db839f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shoes/6.png
// module id = 1103
// module chunks = 0